(function (window, document) {
  'use strict';
  if (!window.requestAnimationFrame) { return; }
  /* ─── small helpers ─────────────────────────────────────────────────────── */
  function maxScroll(el) { return Math.max(0, el.scrollWidth - el.clientWidth); }
  function setScroll(el, val) {    el.scrollLeft = Math.min(Math.max(val, 0), maxScroll(el));  }
  function easeInOut(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
  function toEl(html) {
    if (!html) { return null; }
    if (html.nodeType) { return html; }
    if (html.jquery) { return html[0] || null; }
    var box = document.createElement('div');
    box.innerHTML = String(html).replace(/^\s+|\s+$/g, '');
    return box.firstElementChild || null;
  }
  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var src = arguments[i];
      if (!src) { continue; }
      for (var k in src) {
        if (Object.prototype.hasOwnProperty.call(src, k)) { target[k] = src[k]; }
      }
    }
    return target;
  }
  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var DEFAULTS = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev">Previous</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>',
    dots: false,
    scrollbar: true,     // draggable thumb under the track
    draggable: true,     // mouse drag on the slides (touch uses native scroll)
    speed: 400,          // arrow / dot animation duration in ms
    autoplay: false,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    variableWidth: false,
    responsive: null      // slick shape: [{ breakpoint, settings }]
  };
  /* ─── engine ────────────────────────────────────────────────────────────── */
  function SmoothSlider(el, options) {
    this.el = el;
    this.options = assign({}, DEFAULTS, options || {});
    this.settings = this.options;
    this.slides = [];
    this.loop = false;
    this._anim = 0;
    this._didDrag = false;
    this._paused = false;
    this.build();
  }
  SmoothSlider.prototype.build = function () {
    var el = this.el;
    var self = this;
    var kids = [];
    var i;

    for (i = 0; i < el.children.length; i++) { kids.push(el.children[i]); }
    if (!kids.length) { return; }

    this.list = document.createElement('div');
    this.list.className = 'slick-list ss-list';
    this.track = document.createElement('div');
    this.track.className = 'slick-track ss-track';

    for (i = 0; i < kids.length; i++) {
      var slide = document.createElement('div');
      slide.className = 'slick-slide ss-slide';
      slide.setAttribute('data-slick-index', String(i));
      var inner = document.createElement('div');
      inner.appendChild(kids[i]);
      slide.appendChild(inner);
      this.track.appendChild(slide);
      this.slides.push(slide);
    }

    this.list.appendChild(this.track);
    el.appendChild(this.list);
    el.classList.add('slick-slider', 'slick-initialized', 'ss-slider');

    this.buildArrows();
    this.buildDots();
    // this.buildScrollbar();

    this.applySettings();
    this.sizeSlides();
    this.setupLoop();
    this.renderDots();
    this.update();

    this.onScroll = function () { self.update(); };
    this.list.addEventListener('scroll', this.onScroll, { passive: true });

    this.onResize = function () {
      if (self._rt) { window.clearTimeout(self._rt); }
      self._rt = window.setTimeout(function () { self.refresh(true); }, 150);
    };
    window.addEventListener('resize', this.onResize, { passive: true });

    // Re-measure whenever the container's own width changes — covers sliders
    // that were display:none at init and sliders revealed by a media query.
    if (window.ResizeObserver) {
      this.ro = new window.ResizeObserver(function () {
        var w = self.list.clientWidth;
        if (!w || Math.abs(w - (self._lastWidth || 0)) < 2) { return; }
        if (self._rot) { window.clearTimeout(self._rot); }
        self._rot = window.setTimeout(function () { self.refresh(true); }, 60);
      });
      this.ro.observe(this.list);
    }

    this.bindDrag();
    this.bindAutoplay();

    // Second pass once images have laid out — widths and thumb size settle.
    window.setTimeout(function () { self.refresh(false); self.waitForWidth(); }, 300);
  };

  /* Built with no width (hidden parent) and no ResizeObserver support / no
     resize event to lean on: keep checking briefly until the width is real. */
  SmoothSlider.prototype.waitForWidth = function () {
    if (this._lastWidth || this._waiting) { return; }
    var self = this;
    var tries = 0;
    this._waiting = window.setInterval(function () {
      if (!self.list) { window.clearInterval(self._waiting); self._waiting = null; return; }
      if (self.list.clientWidth) {
        window.clearInterval(self._waiting);
        self._waiting = null;
        self.refresh(false);
      } else if (++tries > 40) {
        window.clearInterval(self._waiting);
        self._waiting = null;
      }
    }, 400);
  };

  /* ── responsive settings (slick semantics: settings apply at <= breakpoint) */

  SmoothSlider.prototype.applySettings = function () {
    var o = this.options;
    var next = assign({}, o);
    var list = o.responsive;

    if (list && list.length) {
      var w = window.innerWidth || document.documentElement.clientWidth;
      var best = null;
      for (var i = 0; i < list.length; i++) {
        var r = list[i];
        if (!r || !r.breakpoint) { continue; }
        if (w <= r.breakpoint && (!best || r.breakpoint < best.breakpoint)) { best = r; }
      }
      if (best && best.settings && best.settings !== 'unslick') {
        assign(next, best.settings);
      }
    }

    next.slidesToShow = Math.max(parseFloat(next.slidesToShow) || 1, 0.1);
    next.slidesToScroll = Math.max(parseFloat(next.slidesToScroll) || 1, 0.1);
    this.settings = next;
  };

  SmoothSlider.prototype.sizeSlides = function () {
    var all = this.slides;
    var listWidth = this.list.clientWidth;
    // Built inside something hidden (cart drawer, mobile-only block): leave the
    // slides at their natural width and wait for the width to become real.
    if (!listWidth) { return; }
    this._lastWidth = listWidth;
    // Size from the CONTENT width, like slick does — themes create a "peek" of
    // the next slide by padding .slick-list (e.g. the Our Creations section on
    // mobile: padding: 0 125px 0 0). Using clientWidth would swallow that
    // padding into the slide and the peek would disappear.
    var cs = window.getComputedStyle(this.list);
    var pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
    var width = Math.max(listWidth - pad, 1) / this.settings.slidesToShow;
    for (var i = 0; i < all.length; i++) {
      all[i].style.width = this.settings.variableWidth ? '' : width + 'px';
    }
  };

  /* ── controls ───────────────────────────────────────────────────────────── */

  SmoothSlider.prototype.buildArrows = function () {
    var self = this;
    if (this.settings.arrows === false) { return; }

    this.prevArrow = toEl(this.options.prevArrow || DEFAULTS.prevArrow);
    this.nextArrow = toEl(this.options.nextArrow || DEFAULTS.nextArrow);

    if (this.prevArrow) {
      this.prevArrow.classList.add('slick-prev', 'slick-arrow', 'ss-arrow');
      this.prevArrow.setAttribute('aria-label', 'Previous');
      this.el.insertBefore(this.prevArrow, this.list);
      this.prevArrow.addEventListener('click', function (e) {
        e.preventDefault(); self.prev();
      });
    }
    if (this.nextArrow) {
      this.nextArrow.classList.add('slick-next', 'slick-arrow', 'ss-arrow');
      this.nextArrow.setAttribute('aria-label', 'Next');
      this.el.appendChild(this.nextArrow);
      this.nextArrow.addEventListener('click', function (e) {
        e.preventDefault(); self.next();
      });
    }
  };

  SmoothSlider.prototype.buildDots = function () {
    if (!this.options.dots) { return; }
    var self = this;
    this.dotsEl = document.createElement('ul');
    this.dotsEl.className = 'slick-dots ss-dots';
    this.el.appendChild(this.dotsEl);
    this.el.classList.add('slick-dotted');
    this.dotsEl.addEventListener('click', function (e) {
      var li = e.target.closest ? e.target.closest('li') : null;
      if (!li || !li.parentNode) { return; }
      e.preventDefault();
      var idx = Array.prototype.indexOf.call(self.dotsEl.children, li);
      if (idx > -1) { self.goTo(idx * self.settings.slidesToScroll); }
    });
  };

  SmoothSlider.prototype.renderDots = function () {
    if (!this.dotsEl) { return; }
    var count = this.slides.length;
    var show = this.settings.slidesToShow;
    var scroll = this.settings.slidesToScroll;
    var pages = Math.max(1, Math.ceil((count - show) / scroll) + 1);
    if (this.dotsEl.children.length === pages) { return; }
    var html = '';
    for (var i = 0; i < pages; i++) {
      html += '<li><button type="button">' + (i + 1) + '</button></li>';
    }
    this.dotsEl.innerHTML = html;
    this.dotsEl.classList.toggle('ss-hidden', pages < 2);
  };

//   SmoothSlider.prototype.buildScrollbar = function () {
//     if (!this.settings.scrollbar) { return; }
//     this.scrollbar = document.createElement('div');
//     this.scrollbar.className = 'ss-scrollbar';
//     this.thumb = document.createElement('div');
//     this.thumb.className = 'ss-scrollbar-thumb';
//     this.scrollbar.appendChild(this.thumb);
//     this.el.appendChild(this.scrollbar);

//     var self = this;
//     this.scrollbar.addEventListener('click', function (e) {
//       if (e.target === self.thumb) { return; }
//       var rect = self.scrollbar.getBoundingClientRect();
//       var tw = self.thumb.offsetWidth;
//       var usable = self.scrollbar.offsetWidth - tw;
//       if (usable <= 0) { return; }
//       var ratio = Math.min(Math.max((e.clientX - rect.left - tw / 2) / usable, 0), 1);
//       self.animateTo(ratio * maxScroll(self.list), self.settings.speed);
//     });
//   };

  /* ── position maths ─────────────────────────────────────────────────────── */

  SmoothSlider.prototype.pos = function () { return this.list.scrollLeft; };

  SmoothSlider.prototype.setPos = function (val) { setScroll(this.list, val); };

  /* Distance between the leading edges of two consecutive slides (incl. gaps) */
  SmoothSlider.prototype.slideStride = function () {
    var all = this.slides;
    if (all.length > 1) {
      var a = all[0].getBoundingClientRect();
      var b = all[1].getBoundingClientRect();
      var d = Math.abs(b.left - a.left);
      if (d > 1) { return d; }
    }
    return all.length ? all[0].getBoundingClientRect().width : this.list.clientWidth;
  };

  SmoothSlider.prototype.pageStep = function () {
    return this.slideStride() * this.settings.slidesToScroll;
  };

  /* Scroll offset that brings a slide's left edge to the viewport's left edge */
  SmoothSlider.prototype.offsetOf = function (slide) {
    var lr = this.list.getBoundingClientRect();
    var sr = slide.getBoundingClientRect();
    return (sr.left - lr.left) + this.pos();
  };

  SmoothSlider.prototype.currentIndex = function () {
    var stride = this.slideStride() || 1;
    return Math.max(0, Math.min(Math.round(this.pos() / stride), this.slides.length - 1));
  };

  /* ── animation ──────────────────────────────────────────────────────────── */

  SmoothSlider.prototype.stopAnim = function () { this._anim++; this._animating = false; };

  SmoothSlider.prototype.animateTo = function (target, duration, done) {
    var self = this;
    var list = this.list;
    var max = maxScroll(list);
    var start = this.pos();
    target = Math.min(Math.max(target, 0), max);
    var delta = target - start;

    this.stopAnim();
    if (Math.abs(delta) < 1) { if (done) { done.call(this); } return; }

    if (reduceMotion || duration <= 0) {
      setScroll(list, target);
      this.update();
      if (done) { done.call(this); }
      return;
    }

    var id = this._anim;
    var t0 = null;
    this._animating = true;
    (function step(now) {
      if (id !== self._anim) { return; }
      if (t0 === null) { t0 = now; }
      var p = Math.min((now - t0) / duration, 1);
      setScroll(list, start + delta * easeInOut(p));
      if (p >= 1) { self._animating = false; }
      self.update();
      if (p < 1) { window.requestAnimationFrame(step); }
      else if (done) { done.call(self); }
    })(window.performance ? window.performance.now() : Date.now());
  };

  /* ── public movement ────────────────────────────────────────────────────── */

  SmoothSlider.prototype.next = function () {
    this.animateTo(this.pos() + this.pageStep(), this.settings.speed);
  };

  SmoothSlider.prototype.prev = function () {
    this.animateTo(this.pos() - this.pageStep(), this.settings.speed);
  };

  SmoothSlider.prototype.goTo = function (index, instant) {
    index = Math.max(0, Math.min(parseInt(index, 10) || 0, this.slides.length - 1));
    var target = this.offsetOf(this.slides[index]);
    if (instant) { this.stopAnim(); this.setPos(target); this.update(); }
    else { this.animateTo(target, this.settings.speed); }
  };

  /* ── state sync ─────────────────────────────────────────────────────────── */

  SmoothSlider.prototype.update = function () {
    var list = this.list;
    var max = maxScroll(list);
    var pos = this.pos();
    var i;

    if (this.prevArrow) {
      this.prevArrow.classList.toggle('slick-disabled', pos <= 2);
      this.prevArrow.setAttribute('aria-disabled', pos <= 2 ? 'true' : 'false');
    }
    if (this.nextArrow) {
      var atEnd = pos >= max - 2;
      this.nextArrow.classList.toggle('slick-disabled', atEnd);
      this.nextArrow.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }
    if (this.prevArrow || this.nextArrow) {
      this.el.classList.toggle('ss-no-scroll', max <= 2);
    }

    if (this.scrollbar && this.thumb) {
      var trackW = this.scrollbar.offsetWidth;
      var ratio = list.clientWidth / (list.scrollWidth || 1);
      var thumbW = Math.max(Math.min(ratio, 1) * trackW, 30);
      this.thumb.style.width = thumbW + 'px';
      this.scrollbar.classList.toggle('ss-hidden', max <= 2);
      var maxLeft = Math.max(0, trackW - thumbW);
      var travel = max > 0 ? (pos / max) * maxLeft : 0;
      this.thumb.style.left = Math.min(Math.max(travel, 0), maxLeft) + 'px';
    }

    var lr = list.getBoundingClientRect();
    var current = -1;
    for (i = 0; i < this.slides.length; i++) {
      var sr = this.slides[i].getBoundingClientRect();
      var visible = sr.right > lr.left + 1 && sr.left < lr.right - 1;
      var whole = sr.left >= lr.left - 1 && sr.right <= lr.right + 1;
      this.slides[i].classList.toggle('slick-active', whole || visible);
      if (visible && current === -1) { current = i; }
      this.slides[i].classList.remove('slick-current');
    }
    if (current > -1) { this.slides[current].classList.add('slick-current'); }

    if (this.dotsEl && this.dotsEl.children.length) {
      var stride = this.slideStride() || 1;
      var page = Math.round(pos / (stride * this.settings.slidesToScroll));
      page = Math.max(0, Math.min(page, this.dotsEl.children.length - 1));
      for (i = 0; i < this.dotsEl.children.length; i++) {
        this.dotsEl.children[i].classList.toggle('slick-active', i === page);
      }
    }

  };

  SmoothSlider.prototype.refresh = function (keepIndex) {
    if (!this.list) { return; }
    var index = keepIndex ? this.currentIndex() : -1;
    this.applySettings();
    this.sizeSlides();
    this.setupLoop();
    this.renderDots();
    if (index > 0) { this.goTo(index, true); }
    this.update();
  };
  SmoothSlider.prototype.setupLoop = function () {
    this.loop = !!(this.settings.autoplay && this.settings.infinite !== false &&
                   this.slides.length > 1 && maxScroll(this.list) > 2);
  };

  SmoothSlider.prototype.rotate = function (count) {
    if (!this.slides.length) { return; }
    var stride = this.slideStride();
    var moved = 0;
    for (var i = 0; i < count && this.slides.length > 1; i++) {
      var first = this.slides.shift();
      this.track.appendChild(first);
      this.slides.push(first);
      moved++;
    }
    if (!moved) { return; }
    this.stopAnim();
    this.setPos(Math.max(0, this.pos() - moved * stride));
    this.update();
  };

  SmoothSlider.prototype.bindAutoplay = function () {
    if (!this.settings.autoplay) { return; }
    var self = this;

    this.play = function () {
      self.stop();
      self._timer = window.setInterval(function () {
        if (self._paused || self._dragging || document.hidden) { return; }
        var pos = self.pos();
        var max = maxScroll(self.list);
        var hop = Math.max(1, Math.round(self.settings.slidesToScroll));

        if (self.loop) {
          self.animateTo(pos + self.slideStride() * hop, self.settings.speed, function () {
            self.rotate(hop);
          });
        } else if (pos >= max - 2) {
          self.animateTo(0, self.settings.speed);
        } else {
          self.animateTo(pos + self.pageStep(), self.settings.speed);
        }
      }, this.settings.autoplaySpeed);
    };
    this.stop = function () {
      if (self._timer) { window.clearInterval(self._timer); self._timer = null; }
    };

    if (this.settings.pauseOnHover) {
      this.el.addEventListener('mouseenter', function () { self._paused = true; });
      this.el.addEventListener('mouseleave', function () { self._paused = false; });
    }
    this.play();
  };

  /* ── dragging (mouse on slides, any pointer on the thumb) ───────────────── */

  SmoothSlider.prototype.bindDrag = function () {
    var self = this;
    var hasPointer = !!window.PointerEvent;

    var drag = { active: false, thumb: false, startX: 0, startY: 0,
                 startPos: 0, lastX: 0, lastT: 0, vel: 0, dir: null };

    function down(e, isThumb) {
      if (!isThumb) {
        if (self.settings.draggable === false) { return; }
        // Touch and pen keep the browser's own (smoother) inertial scrolling.
        if (hasPointer && e.pointerType && e.pointerType !== 'mouse') { return; }
        if (e.button !== undefined && e.button !== 0) { return; }
        if (e.target.closest && e.target.closest('input, textarea, select, button, .ss-arrow')) { return; }
      }
      self.stopAnim();
      drag.active = true;
      drag.thumb = isThumb;
      drag.startX = e.clientX;
      drag.startY = e.clientY;
      drag.startPos = self.pos();
      drag.lastX = e.clientX;
      drag.lastT = Date.now();
      drag.vel = 0;
      drag.dir = isThumb ? 'h' : null;
      self._didDrag = false;
      self._dragging = true;
      if (isThumb) { self.thumb.classList.add('is-dragging'); }

      if (hasPointer && e.pointerId !== undefined) {
        drag.pointerId = e.pointerId;
        if (isThumb) {
          drag.target = self.thumb;
          try { drag.target.setPointerCapture(e.pointerId); } catch (err) {}
        }
        document.addEventListener('pointermove', move);
        document.addEventListener('pointerup', up);
        document.addEventListener('pointercancel', up);
      } else {
        document.addEventListener('mousemove', move);
        document.addEventListener('mouseup', up);
      }
      if (isThumb && e.preventDefault) { e.preventDefault(); }
    }

    function move(e) {
      if (!drag.active) { return; }
      var dx = e.clientX - drag.startX;
      var dy = e.clientY - drag.startY;

      if (!drag.dir && (Math.abs(dx) > 4 || Math.abs(dy) > 4)) {
        drag.dir = Math.abs(dx) >= Math.abs(dy) ? 'h' : 'v';
      }
      if (drag.dir === 'v') { end(); return; }
      if (drag.dir === 'h') {
        if (!drag.thumb && !drag.captured) {
          self.list.classList.add('is-dragging');
          // Now that this is definitely a drag, capturing is safe — and it keeps
          // the gesture alive if the cursor runs outside the slider or window.
          drag.captured = true;
          if (drag.pointerId !== undefined && self.list.setPointerCapture) {
            try { self.list.setPointerCapture(drag.pointerId); drag.target = self.list; } catch (err) {}
          }
        }
        if (e.cancelable) { e.preventDefault(); }
      }

      var now = Date.now();
      var dt = now - drag.lastT || 1;
      drag.vel = (e.clientX - drag.lastX) / dt;
      drag.lastX = e.clientX;
      drag.lastT = now;
      if (Math.abs(dx) > 3) { self._didDrag = true; }

      if (drag.thumb) {
        var maxDrag = Math.max(0, self.scrollbar.offsetWidth - self.thumb.offsetWidth);
        var max = maxScroll(self.list);
        if (maxDrag <= 0 || max <= 0) { return; }
        setScroll(self.list, drag.startPos + (dx / maxDrag) * max);
      } else {
        // Dragging right pulls earlier content in — scroll offset decreases.
        setScroll(self.list, drag.startPos - dx);
      }
      self.update();
    }

    function up() {
      if (!drag.active) { return; }
      var vel = drag.vel;
      var thumb = drag.thumb;
      end();
      if (!thumb && Math.abs(vel) > 0.1) {
        var momentum = Math.max(Math.min(-vel * 180, 600), -600);
        self.animateTo(self.pos() + momentum, 450);
      }
    }

    function end() {
      drag.active = false;
      self._dragging = false;
      if (self.list) { self.list.classList.remove('is-dragging'); }
      if (self.thumb) { self.thumb.classList.remove('is-dragging'); }
      if (drag.target && drag.pointerId !== undefined && drag.target.releasePointerCapture) {
        try { drag.target.releasePointerCapture(drag.pointerId); } catch (err) {}
      }
      drag.target = null;
      drag.captured = false;
      drag.pointerId = undefined;
      document.removeEventListener('pointermove', move);
      document.removeEventListener('pointerup', up);
      document.removeEventListener('pointercancel', up);
      document.removeEventListener('mousemove', move);
      document.removeEventListener('mouseup', up);
      window.setTimeout(function () { self._didDrag = false; }, 60);
    }

    if (hasPointer) {
      this.list.addEventListener('pointerdown', function (e) { down(e, false); });
      if (this.thumb) {
        this.thumb.addEventListener('pointerdown', function (e) { e.stopPropagation(); down(e, true); });
      }
    } else {
      this.list.addEventListener('mousedown', function (e) { down(e, false); });
      if (this.thumb) {
        this.thumb.addEventListener('mousedown', function (e) { e.stopPropagation(); down(e, true); });
      }
    }

    // A drag must never fire the link/click underneath it.
    this.list.addEventListener('click', function (e) {
      if (self._didDrag) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    this.list.addEventListener('dragstart', function (e) { e.preventDefault(); });
  };

  /* ── teardown ───────────────────────────────────────────────────────────── */

  SmoothSlider.prototype.destroy = function () {
    var el = this.el;
    var i;

    if (this.stop) { this.stop(); }
    this.stopAnim();
    if (this.onScroll && this.list) { this.list.removeEventListener('scroll', this.onScroll); }
    if (this.onResize) { window.removeEventListener('resize', this.onResize); }
    if (this.ro) { this.ro.disconnect(); this.ro = null; }
    if (this._waiting) { window.clearInterval(this._waiting); this._waiting = null; }

    for (i = 0; i < this.slides.length; i++) {
      var inner = this.slides[i].firstElementChild;
      var child = inner && inner.firstElementChild;
      if (child) { el.appendChild(child); }
    }
    if (this.list && this.list.parentNode) { this.list.parentNode.removeChild(this.list); }
    if (this.prevArrow && this.prevArrow.parentNode) { this.prevArrow.parentNode.removeChild(this.prevArrow); }
    if (this.nextArrow && this.nextArrow.parentNode) { this.nextArrow.parentNode.removeChild(this.nextArrow); }
    if (this.dotsEl && this.dotsEl.parentNode) { this.dotsEl.parentNode.removeChild(this.dotsEl); }
    if (this.scrollbar && this.scrollbar.parentNode) { this.scrollbar.parentNode.removeChild(this.scrollbar); }

    el.classList.remove('slick-slider', 'slick-initialized', 'slick-dotted', 'ss-slider', 'ss-no-scroll');
    this.slides = [];
    this.loop = false;
    el.smoothSlider = null;
  };

  /* slick-style string API */
  SmoothSlider.prototype.call = function (name, args) {
    args = args || [];
    switch (name) {
      case 'unslick':
      case 'destroy':       this.destroy(); return;
      case 'setPosition':
      case 'resize':
      case 'refresh':       this.refresh(true); return;
      case 'slickGoTo':     this.goTo(args[0], args[1]); return;
      case 'slickNext':     this.next(); return;
      case 'slickPrev':     this.prev(); return;
      case 'slickPause':    this._paused = true; return;
      case 'slickPlay':     this._paused = false; return;
      case 'slickCurrentSlide': return this.currentIndex();
      case 'getSlick':      return this;
      default:              return;
    }
  };
  function mapOptions(opts) {
    var o = assign({}, opts || {});
    var show = parseFloat(o.slidesToShow) || 1;
    if (o.scrollbar === undefined) { o.scrollbar = show > 1 && !o.autoplay; }
    if (o.scrollbar) { o.dots = false; }
    if (o.swipe === false) { o.draggable = false; }
    if (o.speed === undefined) { o.speed = 400; }

    if (o.responsive && o.responsive.length) {
      for (var i = 0; i < o.responsive.length; i++) {
        var s = o.responsive[i] && o.responsive[i].settings;
        if (s && s !== 'unslick' && o.scrollbar && s.dots) { s.dots = false; }
      }
    }
    return o;
  }

  function create(el, opts) {
    if (!el || el.nodeType !== 1) { return null; }
    if (el.smoothSlider) { return el.smoothSlider; }
    var inst = new SmoothSlider(el, mapOptions(opts));
    if (!inst.list) { return null; }  
    el.smoothSlider = inst;
    return inst;
  }

  function init(root, selector, opts) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) { create(nodes[i], opts); }
  }

  window.SmoothSlider = {
    create: create,
    init: init,
    get: function (el) { return el && el.smoothSlider; },
    Slider: SmoothSlider
  };
  function attach($) {
    if (!$ || !$.fn || $.fn.smoothSlider) { return; }
    $.fn.smoothSlider = function () {
      var opt = arguments[0];
      var args = Array.prototype.slice.call(arguments, 1);
      var ret;
      for (var i = 0; i < this.length; i++) {
        var el = this[i];
        if (opt === undefined || typeof opt === 'object') {
          create(el, opt || {});
        } else if (typeof opt === 'string') {
          var inst = el.smoothSlider;
          if (inst) {
            var r = inst.call(opt, args);
            if (r !== undefined) { ret = r; }
          }
        }
      }
      return ret === undefined ? this : ret;
    };
  }

  attach(window.jQuery);
  if (window.$ && window.$ !== window.jQuery) { attach(window.$); }
  if (!window.jQuery) {
    var tries = 0;
    var poll = window.setInterval(function () {
      if (window.jQuery) { attach(window.jQuery); window.clearInterval(poll); }
      else if (++tries > 120) { window.clearInterval(poll); }
    }, 50);
  }

})(window, document);